<template>
    <page-layout
        hide-footer
    >
        <template #header>
            <step-header
                title="Orders"
                :is-loading="isLoading"
                :use-exit-modal="false"
                skip-steps
            />
        </template>
        <template #default>
            <g-loader v-if="isLoading" type="fixed" />
            <template v-else>
                <g-level class="is-fullwidth g-mb-4">
                    <g-level-item>
                        <g-typography>{{ numberOfOrdersTitle }}</g-typography>
                    </g-level-item>
                    <g-level-item v-if="canAddAdditionalOrders" slot="right">
                        <g-button
                            size="small"
                            class="g-border-0"
                            icon="plus"
                            :route="{ name: 'v2.activation.brief.products', params: { isAdditionalOrder: true } }"
                        >
                            Add Order
                        </g-button>
                    </g-level-item>
                </g-level>

                <g-base-box
                    border-radius="large"
                    padding="none"
                    border
                >
                    <template v-for="(order, index) in orders">
                        <div :key="order.id">
                            <product-preview
                                :brief="brief"
                                :order="order"
                                :products="order.products"
                                class="g-m-5"
                                :route="{name: 'v2.activation.brief.order', params: { order_id: order.id }}"
                                hide-divider
                            />

                            <g-divider v-if="index < orders.length - 1" />
                        </div>
                    </template>
                </g-base-box>

                <g-level v-if="numberOfPages > 1" class="g-mt-4">
                    <g-level-item slot="center">
                        <g-pagination size="small" v-model:current="page" :default-page-size="1" :total="numberOfPages" />
                    </g-level-item>
                </g-level>
            </template>
        </template>
    </page-layout>
</template>

<script>
    import {clone} from 'lodash'
    import PageLayout from '../../../../layouts/PageLayout';
    import ActivationBriefOrderMixin from '../../mixins/ActivationBriefOrderMixin';
    import StepHeader from '../StepHeader';
    import { pluralize } from '../../../../../helpers/string-helpers';
    import ProductPreview from '../products/ProductPreview';

    export default {
        name:       'ActivationBriefOrdersListView',
        components: {
            PageLayout,
            StepHeader,
            ProductPreview,
        },
        mixins: [
            ActivationBriefOrderMixin,
        ],
        props: {
            isLoading: {
                type:    Boolean,
                default: false,
            },
            orders: {
                type:     Array,
                required: true,
            },
            currentPage: {
                type:     Number,
                default:  1,
            },
            numberOfPages: {
                type:     Number,
                default:  1,
            },
            loadOrdersPage: {
                type:     Function,
                required: true,
            },
        },
        data() {
            return {
                page: clone(this.currentPage),
            };
        },
        computed: {
            numberOfOrdersTitle() {
                  return this.numberOfOrders + ' ' + pluralize(this.numberOfOrders, 'Order');
            },
        },
        watch: {
            page() {
                this.loadOrdersPage(this.page);
            }
        }
    };
</script>
